import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { StreeningIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { useAutoTestCreate } from 'modules/auto-test';
import { globalConst, onTrackYandexGoal } from 'modules/global';

import { Visible } from 'components';

import BannerImages from './banner-images';
import CheckList from './check-list';

const Banner = () => {
  const t = useTranslations();
  const { push } = useRouter();
  const { mutate, isLoading } = useAutoTestCreate();
  const isRouteLoading = useAppSelector(({ routeLoading }) => routeLoading.isRouteLoading);

  const onCreateAutoTest = () => {
    mutate(undefined, {
      onSuccess: data => {
        if (data?.is_allowed === false) {
          onTrackYandexGoal(globalConst.yandexGoalKeys.mock_avto_test_pro_push);
          return push(globalConst.pageNames.PRO);
        }
        return push(globalConst.pageNames.AUTO_TEST_PROCESS);
      }
    });
  };

  return (
    <div className="relative w-full">
      <div className="relative flex  w-full flex-col items-center justify-between overflow-hidden rounded-xl bg-white bg-[url('/images/auto-test-banner-bg.webp')] bg-cover bg-center shadow-sm md:flex-row">
        <div className="relative z-10 max-w-full p-6 sm:p-8 md:max-w-[50%] md:py-10 md:pl-10">
          <h1 className="text-lg font-bold uppercase sm:text-2xl">
            {t('avtotest_savollariga_biz_bilan_birga_tayyorlaning')}
          </h1>
          <div className="mt-5 space-y-5 text-gray-800">
            <CheckList text={t('bu_test_B_toifadagi_haydovchilik_guvohnomasi_uchun_moljallangan')} />
            <CheckList text={t('agar_2_tadan_ortiq_xato_qilsangiz_testdan_otolmaysiz')} />
            <CheckList text={t('testni_yechish_uchun_25_daqiqa_vaqt_beriladi')} />
            <CheckList text={t('avto_test_20_ta_savoldan_iborat')} />
          </div>
          <div className="mt-3 text-sm font-semibold text-red-500">
            {t('testni_faqat_bir_marta_bepul_topshirish_mumkin')}
          </div>
          <div className="flex items-center justify-center md:justify-start">
            <button
              disabled={isLoading || isRouteLoading}
              onClick={onCreateAutoTest}
              className="w-70 mt-9 flex cursor-pointer items-center justify-center gap-2 rounded-lg bg-green-600 px-5 py-3 text-white disabled:opacity-60"
            >
              <Visible if={isLoading || isRouteLoading} else={<StreeningIcon />}>
                <LoadingOutlined />
              </Visible>
              {t('mock_imtihon_boshlash')}
            </button>
          </div>
        </div>
        <div className="relative min-h-[18rem] flex-1 sm:min-h-[22rem] md:min-h-[28rem]">
          <BannerImages />
        </div>
      </div>
    </div>
  );
};

export default Banner;
